import script from "./TAtividades.vue?vue&type=script&lang=ts&setup=true"
export * from "./TAtividades.vue?vue&type=script&lang=ts&setup=true"

import "./TAtividades.vue?vue&type=style&index=0&id=8b30af3c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b30af3c"]])

export default __exports__